var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dir":"rtl"}},[_c('Navbar',{attrs:{"activeTabs":_vm.activeTabs}}),_c('v-main',[_c('router-view',{attrs:{"access":_vm.userAccess},on:{"getActiveTabs":_vm.getActiveTabs}})],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }